module.exports = __webpack_public_path__ + "fonts/Roboto-Bold-webfont.3dcc0e0f.ttf";